<template>
  <div class="container">
    <div class="car">
      <img
        class="car_img"
        src="https://static.etcmall.cn/etcissue/trucking/banner/trucking_banner.png"
        alt
      />
    </div>
    <div class="notice">
      <div class="notice_text">
        <span class="left"></span>
        <span class="right">办理须知(注意)</span>
      </div>
      <div class="particulars">
        <div class="particulars_item">
          <div class="title_item">1.</div>
          <span>产品目前只向个人用户开放，以身份证为有效证件实名发行。</span>
        </div>
        <div class="particulars_item">
          <div class="title_item">2.</div>
          <span>用户的手机要操持畅通，因为办理过程中需要接受验证码。</span>
        </div>
        <div class="particulars_item">
          <div class="title_item">3.</div>
          <span>需要用户准备好人车合影的照片（手持身份证正面与车头合照照片）</span>
        </div>
        <div class="particulars_item">
          <div class="title_item">4.</div>
          <span>用户应保证上传的资料真实有效。</span>
        </div>
        <div class="particulars_item">
          <div class="title_item">5.</div>
          <span>集装箱车辆在本平台办理得ETC卡无法进行集装箱优惠预约。</span>
        </div>
        <div class="particulars_item last">
          注意:当前仅限货车办理，支持全国通行。
        </div>
      </div>

      <div class="notice_text">
        <span class="left"></span>
        <span class="right">办理流程</span>
      </div>
      <div class="particulars transaction">
        <div class="particulars_item">
          <div class="title_item">1.</div>
          <span>信息认证</span>
          <br/>
          <span class="introduce">身份证信息与车牌认证</span>
        </div>
        <div class="particulars_item">
          <div class="title_item">2.</div>
          <span>选择发行机构</span>
          <br/>
          <span class="introduce">选择办理ETC的发行机构</span>
        </div>
        <div class="particulars_item">
          <div class="title_item">3.</div>
          <span>选择授信银行</span>
          <br/>
          <span class="introduce">银行卡授信etc代扣的银行</span>
        </div>
        <div class="particulars_item">
          <div class="title_item">4.</div>
          <span>选择增信保险</span>
          <br/>
          <span class="introduce">选择保险产品进行增信</span>
        </div>
      </div>
    </div>
    <div class="select_agreement">
      <cube-checkbox v-model="selected"></cube-checkbox>
      <span>
          已阅读并同意以下协议
          <router-link :to="{name:'userServiceAgreement'}">《货车ETC服务协议》</router-link>
      </span>
    </div>
    <div class="button_next">
      <div @click="next()">免费办理并同意协议</div>
    </div>
  </div>
</template>

<script>
import { axios } from '../../util/request'
import { log } from 'util'
export default {
  data(){
    return{
      selected: false,
    }
  },
  methods:{
    next(){
      if(this.selected) {
        axios.post('/User/CheckIsCertified',{userId: sessionStorage.getItem("USER-ID")}).then(data => {      
            if(1 === data.state){  
                axios.post('/Vehicle/CheckIsHasVehicle',{userId: sessionStorage.getItem("USER-ID")}).then(data => {
                  if(1 === data.state){
                    this.$router.push({name:'vehicleDetection'});
                  }else{
                    this.$router.push({name:'vehicleCertify'});
                  }
                });                     
            } else {
              this.$router.push({name:'authentication'});
            }
        });  
      } else {
        this.$createDialog({
          type: 'alert',
          title: '温馨提示',
          content: "请选择同意货车ETC服务协议！",
          icon: 'cubeic-alert'
        }).show()
        return;
      }
    },
    agreement(){
      // 跳转到协议页面
    },
  },
}

</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}
.car {
  width: 100%;
  background: #e98220;
  position: relative;
}
.car .car_img {
  width: 100%;
}

.notice {
  width: 100%;
  background: #fff;
}
.notice .notice_text {
  height: 2.75rem;
  line-height: 2.75rem;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
}
.notice_text .left {
  margin-left: 1rem;
  margin-right: 0.5rem;
  display: inline-block;
  width: 0.2rem;
  height: 0.8rem;
  background: #ea8c3f;
}
.notice_text .right {
  font-weight: 600;
}
.particulars {
  width: 100%;
  padding: 1rem 1.4rem 1rem 1.6rem;
  box-sizing: border-box;
  color: #3e3e3e;
  text-align: left;
}
.particulars_item {
  width: 100%;
  margin-bottom: 1rem;
}
.title_item {
  height: 2rem;
  width: 1rem;
  float: left;
  margin-top: .25rem;
}
.particulars_item span {
  width: 100%;
  font-size: 1rem;
  line-height: 1.6rem;
  margin-bottom: 0.6rem;
}
.last {
  margin-bottom: 0;
}
.introduce {
  color: #838383;
  margin-top: 1rem;
}

.select_agreement {
  height: 1.56rem;
  width: 100%;
  background: #fff;
  padding-bottom: 1rem;
  font-size: 1rem;
  .cube-checkbox {
    display: inline-block;
    height: 1.56rem;
    width: 1.5rem;
    padding-right: 0rem;
    overflow: hidden;
    vertical-align: middle;
    .cube-checkbox-input {
      height: 1rem;
      width: 1rem;
    }
    /deep/ .cube-checkbox-label {
      display: none;
      height: 0;
      width:0;
    }
    
  }
  a {
    color: #1666ea;
  }
}

.button_next {
  height: 5.12rem;
  width: 100%;
  padding: 0 4.5rem;
  box-sizing: border-box;
  background: #fff;
}
.button_next div {
  width: 14.7rem;
  height: 2.3rem;
  line-height: 2.3rem;
  border-radius: 1.15rem;
  // border: none;
  border: 1px solid #f28b35;
  font-size: 0.82rem;
  color: #fc8931;
  background: #fff;
}
</style>